__turbopack_context__.v({
  "Interna": "_8lQl7a_Interna",
  "JornadaAprendizagem": "_8lQl7a_JornadaAprendizagem",
  "arrow": "_8lQl7a_arrow",
  "card": "_8lQl7a_card",
  "carousel": "_8lQl7a_carousel",
  "carouselContainer": "_8lQl7a_carouselContainer",
  "category": "_8lQl7a_category",
  "color-blue-200": "_8lQl7a_color-blue-200",
  "color-blue-600": "_8lQl7a_color-blue-600",
  "color-purple": "_8lQl7a_color-purple",
  "color-yellow": "_8lQl7a_color-yellow",
  "description": "_8lQl7a_description",
  "descriptionArea": "_8lQl7a_descriptionArea",
  "image": "_8lQl7a_image",
  "title": "_8lQl7a_title",
  "titleArea": "_8lQl7a_titleArea",
});
